import { createFileRoute } from '@tanstack/react-router'
import { WebhooksPage } from '../features/developer/WebhooksPage'

export const Route = createFileRoute('/_auth/developer/webhooks')({
  component: WebhooksPage,
})
